import type { IExercise } from '../exercises';

export const FANJUE_EPISODE_08_MATERIALS: IExercise[] = [
  {
    "id": "course-20261008-fanjue-plan-08-01",
    "name": "内旋肌激活",
    "bodyPart": "warmup",
    "equipment": "bodyweight",
    "subCategory": "shoulder",
    "tips": ["肩内旋肌群激活", "改善圆肩体态"],
    "sets": 2,
    "reps": "15次",
    "rpe": 5,
    "restSeconds": 30,
    "isBodyweight": true,
    "isWarmup": true,
    "demoUrl": "/media/collections-20261008/demos/59ed854c310f8643ed26b96f.mp4",
    "videoUrl": "/media/collections-20261008/videos/6929421d19c57efc18f8c9ea.mp4",
    "targetMuscles": ["全身激活肌群"],
    "difficulty": "beginner",
    "source": "焚诀计划 · 第8期",
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-fanjue-plan-08-02",
    "name": "对握高位下拉",
    "bodyPart": "back",
    "equipment": "cable",
    "subCategory": "lat",
    "tips": ["拉至胸上沿", "挤压背阔肌"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "demoUrl": "/media/collections-20261008/demos/4f63767df87a6937b395f64c.mp4",
    "videoUrl": "/media/collections-20261008/videos/8b0bae16fd1f714c6f158d8f.mp4",
    "targetMuscles": ["背阔肌", "肱二头肌"],
    "difficulty": "beginner",
    "source": "焚诀计划 · 第8期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-fanjue-plan-08-03",
    "name": "肘屈伸",
    "bodyPart": "arms",
    "equipment": "bodyweight",
    "subCategory": "triceps",
    "tips": ["大臂固定", "肱三头肌充分收缩"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 45,
    "isBodyweight": true,
    "demoUrl": "/media/collections-20261008/demos/06c9c0376ada737a555f6b89.mp4",
    "videoUrl": "/media/collections-20261008/videos/b8c1737d970f08d00dcd6740.mp4",
    "targetMuscles": ["肱三头肌"],
    "difficulty": "beginner",
    "source": "焚诀计划 · 第8期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
];
